function SchoolFilms(el) {
    this.el = el;
    this._init();
}

SchoolFilms.prototype._init = function () {
    this.innerEl = this.el.querySelector('[data-inner]');
    this.prevBtnEl = this.el.querySelector('[data-nav-btn="prev"]');
    this.nextBtnEl = this.el.querySelector('[data-nav-btn="next"]');

    this.showHideNav(0);
    this._initModal();
    this._addEventListeners();
};

SchoolFilms.prototype._addEventListeners = function () {
    // Make sure the inner element does not go out of screen
    window.addEventListener('resize', () => {
        const bounds = this.innerEl.getBoundingClientRect();
        const leftOffset = this.restrictInnerElPosition(bounds.left);

        if (leftOffset !== bounds.left) {
            gsap.set(this.innerEl, { x: leftOffset });
            this.showHideNav(leftOffset);
        }
    });

    this.el.addEventListener('click', e => {
        if (typeof e.target.dataset.listSchool !== 'undefined') {
            this.activateItem(e.target);
        }
        else if (typeof e.target.dataset.navBtn !== 'undefined') {
            e.preventDefault();

            if (e.target.classList.contains('reverse')) this.reverse();
            else this.forward();
        }
    });

    this.el.addEventListener('click', (e) => {
        if (e.target.classList.contains('jsTriggerSchoolModal')) {
            e.preventDefault();
            
            this.showModal(
                e.target.dataset.title,
                e.target.dataset.levels,
                e.target.dataset.embedUrl,
                e.target.dataset.logoUrl,
                e.target.dataset.desc,
                e.target.dataset.url
            );
        }
    });


    // Modal event listeners
    this.modalEl.addEventListener('click', (e) => {
        if (e.target.classList.contains('jsClose')) {
            this.hideModal();
        }
    });

    window.addEventListener('keyup', (e) => {
        if (e.key.toLowerCase() === 'escape') {
            this.hideModal();
        }
    });
};

SchoolFilms.prototype.activateItem = function (itemEl) {
    if (itemEl.classList.contains('is-active')) return;

    // Disable all items
    const items = this.el.querySelectorAll('[data-list-school]');
    items.forEach(item => item.classList.remove('is-active'));

    // Activate the current item
    itemEl.classList.add('is-active');

    setTimeout(() => {
        // Make sure that the item is fully on the screen
        const innerBounds = this.innerEl.getBoundingClientRect();
        const itemBounds = itemEl.getBoundingClientRect();

        if (itemBounds.right > window.innerWidth) {
            const newPosition = this.restrictInnerElPosition(innerBounds.left - (itemBounds.right - window.innerWidth) - 50);

            gsap.to(this.innerEl, {
                duration: 0.5,
                x: newPosition,
                ease: 'power2.inOut'
            });

            this.showHideNav(newPosition);
        }
        else if (itemBounds.left < 0) {
            const newPosition = this.restrictInnerElPosition(innerBounds.left - itemBounds.left + 50);

            gsap.to(this.innerEl, {
                duration: 0.5,
                x: newPosition,
                ease: 'power2.inOut'
            });

            this.showHideNav(newPosition);
        }
    }, 300);
};

SchoolFilms.prototype.restrictInnerElPosition = function(value) {
    if (value > 0) return 0;

    const bounds = this.innerEl.getBoundingClientRect();
    if (Math.abs(value) > (bounds.width - window.innerWidth)) return -(bounds.width - window.innerWidth);

    return value;
};

SchoolFilms.prototype.reverse = function () {
    const bounds = this.innerEl.getBoundingClientRect();

    if (bounds.width < window.innerWidth) {
        gsap.set(this.el, { clearProps: 'all' });
        return;
    }

    let leftOffset = this.restrictInnerElPosition(bounds.left + (window.innerWidth * 0.8));

    gsap.to(this.innerEl, {
        duration: 0.5,
        x: leftOffset,
        ease: 'power2.inOut'
    });

    this.showHideNav(leftOffset);
};

SchoolFilms.prototype.forward = function () {
    const bounds = this.innerEl.getBoundingClientRect();

    if (bounds.width < window.innerWidth) {
        gsap.set(this.el, { clearProps: 'all' });
        return;
    }

    let leftOffset = this.restrictInnerElPosition(bounds.left - (window.innerWidth * 0.8));

    gsap.to(this.innerEl, {
        duration: 0.5,
        x: leftOffset,
        ease: 'power2.inOut'
    });

    this.showHideNav(leftOffset);
};

SchoolFilms.prototype.showHideNav = function (newLeftPosition) {
    const bounds = this.innerEl.getBoundingClientRect();

    if (bounds.width < window.innerWidth) {
        this.prevBtnEl.disabled = true;
        this.nextBtnEl.disabled = true;

        return;
    }

    if (newLeftPosition === 0) this.prevBtnEl.disabled = true;
    else this.prevBtnEl.disabled = false;

    if (Math.abs(newLeftPosition) >= (bounds.width - window.innerWidth)) this.nextBtnEl.disabled = true;
    else this.nextBtnEl.disabled = false;
};

SchoolFilms.prototype._initModal = function () {
    this.modalEl = document.createElement('div');
    this.modalEl.classList.add('se-school-modal');
    this.modalEl.classList.add('jsClose');

    this.modalEl.innerHTML = `
        <div class="se-school-modal__inner">
            <button class="se-school-modal__close-btn jsClose" data-close-modal>Close</button>

            <div class="se-school-modal__title-wrapper">
                <span class="se-school-modal__title jsTitle"></span>
                <span class="se-school-modal__subtitle jsSubtitle"></span>
            </div>

            <div class="se-school-modal__embed-wrapper">
                <iframe class="jsEmbed" src="" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>

            <div class="se-school-modal__meta">
                <div class="se-school-modal__col logo jsLogo"></div>
                <div class="se-school-modal__col jsDesc default-styles"></div>
                <div class="se-school-modal__col"><a href="" class="se-school-modal__link btn btn--small jsLink" target="_blank"></a></div>
            </div>
        </div>
    `;

    document.body.appendChild(this.modalEl);
};

SchoolFilms.prototype.showModal = function(title, levels, embedUrl, logoUrl, desc, url) {
    this.modalEl.querySelector('.jsTitle').textContent = title;
    this.modalEl.querySelector('.jsSubtitle').textContent = levels;
    this.modalEl.querySelector('.jsEmbed').src = embedUrl;
    this.modalEl.querySelector('.jsLogo').innerHTML = `<img src="${logoUrl}" alt="${title}" />`;
    this.modalEl.querySelector('.jsDesc').innerHTML = desc;
    this.modalEl.querySelector('.jsLink').href = url;
    this.modalEl.querySelector('.jsLink').innerHTML = this.formatUrlForHumans(url);

    this.modalEl.classList.add('is-active');
};

SchoolFilms.prototype.formatUrlForHumans = function(url) {
    url = url.replace('https://', '')
    url = url.replace('www.', '');

    // Remove the last slash
    if (url.substr(-1) === '/') url = url.slice(0, -1);

    return url;
};

SchoolFilms.prototype.hideModal = function() {
    this.modalEl.classList.remove('is-active');
    this.modalEl.querySelector('.jsEmbed').src = '';
};

(function () {
    const schoolFilmEls = document.querySelectorAll('[data-c-school-films]');
    schoolFilmEls.forEach((schoolFilmEl) => new SchoolFilms(schoolFilmEl));
})();